let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("a2D4w")).then(() => parcelRequire('3agfw'));